import React from "react";
import { Helmet } from "react-helmet-async";


export default function CreateAccountPage() {
    
    return (
        <section>
            <Helmet bodyAttributes={{ class: 'login-back' }}>
                <title>Create new account | sec1.io</title>
            </Helmet>
            
        </section>
    );
}